<template>
  <div>
    <div v-for="dialog in dialogs" :key="dialog.id"
         v-if="+dialog.is_active"
         v-bind:class="{'dialog_select': true, 'active': selectedDialogId === dialog.id}"
         @click="selectDialog(dialog.id)">
      <template v-if="displayDetails && displayDetails.orderId">
        <p>{{ types[dialog.type_id] }}
          <strong v-if="dialog.object_id">{{ dialog.object_id }}</strong>
          <template v-if="dialog.order">
          <span v-bind:class="{
                    'badge': true,
                    'badge-warning': dialog.order.status < 0,
                    'badge-info': dialog.order.status >= 0,
                  }">{{ dialog.order.status_label }}</span>
          </template>
          <span v-if="isHasNewMessages(dialog)" class="badge badge-success">сообщения</span></p>
      </template>
      <p v-if="displayDetails && displayDetails.author">({{ dialog.user_id }})
        {{ users && users[dialog.user_id] || 'Пользователь' }}</p>
      <p class="text-muted text-right chat_date">(U:{{ dialog.user_id }} {{ dialog.id }})
        {{ printDate(dialog.created_at, 'DD.MM HH:mm') }}</p>
    </div>
  </div>
</template>

<script>

export default {
  props: ['dialogs', 'onSelect', 'selectedDialogId', 'users', 'displayDetails'],
  data() {
    return {
      types: {
        1: 'Вопрос по заявке',
        2: 'Корректура',
        3: 'Вопрос курьера',
        4: 'Общий вопрос'
      }
    }
  },
  methods: {
    isHasNewMessages(dialog) {
      const messages = dialog.messages.filter((m) => +m.user_id !== this.$currentUID && !((m.acknowledge_by || []).find((a) => +a.user_id === this.$currentUID)));
      return messages && messages.length | false;
    },
    selectDialog(id) {
      if (this.onSelect) {
        this.onSelect(id);
      }
    }
  }
}

</script>

<style scoped>
p {
  margin-bottom: 1px;
}

.dialog_select {
  cursor: pointer;
  border: 1px solid lightgray;
  padding: 5px;
}

.dialog_select:hover {
  background-color: #fbfbfb;
}

.dialog_select.active {
  background-color: #def1f8;
}

.chat_date {
  font-size: 11px;
}
</style>
